/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from 'react';
import { Navigation, Routes } from '../../../navigation';
import { authService } from '../../../services';
import { PageContent } from '../../common';

export const LoginRouter = ( props ) => {

    const loginRedirect = {
        salesforce: () => authService.signInToSalesforce(),
        azure: () => authService.signInToAzure(),
    };

    useEffect( () => {
        if ( authService?._auth?.state?.access_token ) {
            Navigation.push( Routes.Home.buildPath() );
        } else {
            loginRedirect[ props.route.params.loginType ]?.() || Navigation.push( Routes.Portal.buildPath() );
        }

    }, [ authService?._auth?.state?.access_token ] );

    return <PageContent/>;
};
